import { render, staticRenderFns } from "./users.html?vue&type=template&id=9f3827e8&scoped=true&"
import script from "./users.ts?vue&type=script&lang=js&"
export * from "./users.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3827e8",
  null
  
)

export default component.exports